import { API_URL_NEWS } from "@constants/env";
import useApiCall from "@hooks/Shared/useApiCall";
import { INews } from "@interfaces/news";

const useGetNews = (uuid: string) =>
  useApiCall<INews>({
    url: API_URL_NEWS + uuid,
  });

export default useGetNews;
